export default __webpack_public_path__ + "static/img6@2x-ca6e5ad0026f464995a8391cc1a0a99f.jpg";